import RestService from './RestService';
import EventsService from './EventsService';
import MetricsService from './MetricsService';

export default class AnalyticsService extends RestService {
    constructor() {
        super('/analytics');
    }

    get events() {
        return new EventsService(this);
    }

    get metrics() {
        return new MetricsService(this);
    }
}
